export default __webpack_public_path__ + "static/media/covid.76061c6b.svg";